"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _color = require("MeetingsLib/utils/color");

var _BookingFormField = _interopRequireDefault(require("MeetingsLib/components/input/BookingFormField"));

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var _BookActions = require("MeetingsLib/redux/actions/BookActions");

var EmailForm = (0, _createReactClass.default)({
  displayName: "EmailForm",
  propTypes: {
    compact: _propTypes.default.bool,
    setFormValue: _propTypes.default.func.isRequired,
    fetchPublicAvailabilityInfoForOwner: _propTypes.default.func.isRequired,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    markShowedEmailForm: _propTypes.default.func.isRequired,
    EmailFormMarker: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      email: '',
      buttonHover: false
    };
  },
  getEmailIsValid: function getEmailIsValid() {
    var email = this.state.email;
    return Boolean(email && _EmailAddress.default.test(email));
  },
  onEmailChange: function onEmailChange(fieldName, email) {
    this.setState({
      email: email
    });
  },
  onMouseEnter: function onMouseEnter() {
    this.setState({
      buttonHover: true
    });
  },
  onMouseLeave: function onMouseLeave() {
    this.setState({
      buttonHover: false
    });
  },
  getValidation: function getValidation() {
    if (this.getEmailIsValid()) {
      return false;
    }

    return _react.default.createElement(_FormattedMessage.default, {
      message: "prebook.details.errorHelper.email"
    });
  },
  getClassNames: function getClassNames() {
    return 'email-form height-100 p-all-5' + (this.props.compact ? " compact" : "");
  },
  handleEmailSubmit: function handleEmailSubmit(e) {
    e.preventDefault();
    var email = this.state.email;
    var _this$props = this.props,
        setFormValue = _this$props.setFormValue,
        fetchPublicAvailabilityInfoForOwner = _this$props.fetchPublicAvailabilityInfoForOwner,
        markShowedEmailForm = _this$props.markShowedEmailForm;
    setFormValue('email', email);
    fetchPublicAvailabilityInfoForOwner({
      email: email
    }).then(markShowedEmailForm);
  },
  renderButton: function renderButton() {
    var primaryColor = this.props.branding.primaryColor;
    var style = this.state.buttonHover ? (0, _color.getPrimaryButtonHoverStyle)(primaryColor) : (0, _color.getPrimaryButtonStyle)(primaryColor);
    var isValid = this.getEmailIsValid();
    return _react.default.createElement("div", {
      className: "text-center m-top-5"
    }, _react.default.createElement(_UIButton.default, {
      style: style,
      use: "primary",
      disabled: !isValid,
      onClick: this.handleEmailSubmit,
      size: "medium",
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "emailForm.button"
    })));
  },
  render: function render() {
    var _this$props2 = this.props,
        primaryColor = _this$props2.branding.primaryColor,
        EmailFormMarker = _this$props2.EmailFormMarker;
    var classes = this.getClassNames();
    var color = primaryColor;

    var fieldLabel = _react.default.createElement(_FormattedMessage.default, {
      message: "emailForm.placeholder"
    });

    return _react.default.createElement(_UIFlex.default, {
      justify: "around",
      className: classes,
      style: {
        borderColor: color
      }
    }, _react.default.createElement("div", {
      style: {
        maxWidth: '350px'
      }
    }, _react.default.createElement("div", {
      className: "text-center m-top-4"
    }, _react.default.createElement(_UIIllustration.default, {
      name: "meetings",
      width: "60%"
    }), _react.default.createElement(_H.default, {
      className: "m-y-2"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "emailForm.header"
    })), _react.default.createElement("p", {
      className: "m-bottom-4"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "emailForm.text"
    }))), _react.default.createElement(_BookingFormField.default, {
      fieldName: "email",
      fieldLabel: fieldLabel,
      validation: this.getValidation(),
      fieldValue: this.state.email,
      isRequired: true,
      setFormValue: this.onEmailChange,
      autocomplete: "on"
    }), this.renderButton(), _react.default.createElement(EmailFormMarker, null)));
  }
});

var _default = (0, _reactRedux.connect)(function () {
  return {};
}, Object.assign({}, FormActions, {
  fetchPublicAvailabilityInfoForOwner: _BookActions.fetchPublicAvailabilityInfoForOwner
}))(EmailForm);

exports.default = _default;
module.exports = exports.default;